import * as React from 'react';
import { Alert, Button, Spin } from 'antd';

import { MapMarker, MapView } from 'src/core/ui/map.view';
import { CollapseCard } from 'src/app/shared/collapse-card.view';
import { ProductDataService } from 'src/app/products/products/form/product-form.data';
import { ProductCategoryListDataService} from 'src/app/products/product-categories/list/product-category-list.data';
import { ContextService } from 'src/core/services/context.service';

interface Props {
	title: React.ReactNode;
	extra?: React.ReactNode;
	product: ProductMap; // TODO: It is just to test, it must be changed later...
	renderProductSummary?: (productMap: ProductMap, product: ProductItem) => React.ReactNode;
}

interface State {
	activeView: ViewType;
	loadedProduct?: ProductItem;
}

type ViewType = 'collapse' | 'result' | 'product' | 'map';

export class SearchResultItem extends React.Component<Props, State> {
	productDataService: ProductDataService;
	categoryDataService: ProductCategoryListDataService;
	contextService: ContextService;

	constructor(props: Readonly<Props>) {
		super(props);

		this.productDataService = ProductDataService.make();
		this.categoryDataService = ProductCategoryListDataService.make(this.contextService);

		this.state = {
			activeView: 'collapse',
		};
	}

	public render(): React.ReactNode {
		const {
			title,
			extra,
			children,
			product,
		} = this.props;
		const { activeView } = this.state;

		const actions = activeView === 'collapse'
			? undefined
			: [
				<Button
					key="result"
					icon="search"
					onClick={() => this.handleChangeView('result')}
					{...this.getButtonPropsForActiveView('result')}
				>
					Result
				</Button>,
				<Button
					key="product"
					icon="shopping-cart"
					onClick={() => this.handleChangeView('product')}
					{...this.getButtonPropsForActiveView('product')}
				>
					Product Info
				</Button>,
				<Button
					key="map"
					icon="environment"
					onClick={() => this.handleChangeView('map')}
					{...this.getButtonPropsForActiveView('map')}
				>
					Map
				</Button>
			];

		return (
			<CollapseCard
				title={title}
				extra={extra}
				actions={actions}
				initialCollapseState={true}
				onToggleCollapse={this.toggleCollapse}
			>
				{activeView === 'result' && children}
				{activeView === 'product' && this.defaultProductSummaryRenderer(product.internalId)}
				{activeView === 'map' && this.renderMap(product.location)}
			</CollapseCard>
		);
	}

	private toggleCollapse = (collapsed: boolean) => this.setState({
		activeView: collapsed ? 'result' : 'collapse',
	});

	private renderMap(location) {
		var point = location ? { lat: location.latitude, lng: location.longitude } : undefined;

		return (
			<div style={{ width: '100%', height: '50vh' }}>
				<MapView
					center={point}
					zoom={13}
				>
					<MapMarker {...point} />
				</MapView>
			</div>
		);
	}

	private getButtonPropsForActiveView(viewName: ViewType): any {
		const { activeView } = this.state;
		const { product } = this.props;

		return {
			type: activeView === viewName ? 'primary' : undefined,
			disabled: viewName === "map" && product.location == null
				|| viewName === "product" && product.internalId == null
				|| false
		} as any;
	}

	private defaultProductSummaryRenderer = (productId: number): React.ReactNode => {
		const {product, renderProductSummary} = this.props;
		const {loadedProduct} =this.state;
		if(this.props.renderProductSummary && loadedProduct){
			return renderProductSummary(product, loadedProduct);
		}
		else{
			return <div>No esta hecho el summary para este producto</div>
		}
	}

	private handleChangeView = async (viewName: ViewType): Promise<void> => {
		this.setState({
			activeView: viewName
		});
		if (viewName === "product" && this.state.loadedProduct == null && this.props.product.internalId) {
			this.productDataService.addFilter("id", "eq", this.props.product.internalId);
			this.productDataService.addSorting("id", "asc");
			this.productDataService.pageSize = 1;
			await this.productDataService.load(query => query);

			const product = this.productDataService.item;

			this.categoryDataService.addFilter('id', 'eq', product.categoryId);
			this.categoryDataService.addSorting('id', 'asc', true);
			this.categoryDataService.pageSize = 1;
			await this.categoryDataService.load(query => query);

			product.category = this.categoryDataService.item;

			this.setState({
				loadedProduct: product
			});
		}
	};
}



// WEBPACK FOOTER //
// ./src/app/bookings/search/results/search-result-item.tsx